import React, { useState, useRef, useEffect } from "react";

export const delightCustomList = [
  {
    index: 0,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight01.jpg",
    mime_type: "image/png",
    store_id: 2538,
    type: "adver",
  },
  {
    index: 1,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight02.jpg",
    mime_type: "image/png",
    store_id: 2530,
    type: "adver",
  },
  {
    index: 2,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight03.jpg",
    mime_type: "image/png",
    store_id: 2622,
    type: "adver",
  },
  {
    index: 3,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight04.jpg",
    mime_type: "image/png",
    store_id: 2543,
    type: "adver",
  },
  {
    index: 4,
    url_path:
      "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/delight05.jpg",
    mime_type: "image/png",
    store_id: 2608,
    type: "adver",
  },
];

const CustomDelight = (props: { navigateAdStore: any; adverClick: any }) => {
  const renderButtons = (idx: number, storeId: number) => {
    return (
      <>
        <img
          src={`${
            idx === 0
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive01.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button01.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(2538);
            props.adverClick(2538, "레전드고기한상");
          }}
        />
        <img
          src={`${
            idx === 1
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive02.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button02.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(2530);
            props.adverClick(2530, "라쿤피자");
          }}
        />
        <img
          src={`${
            idx === 2
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive03.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button03.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(2622);
            props.adverClick(2622, "BBQ");
          }}
        />
        <img
          src={`${
            idx === 3
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive04.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button04.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(2543);
            props.adverClick(2543, "라홍방마라탕");
          }}
        />
        <img
          src={`${
            idx === 4
              ? "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/buttonActive05.png"
              : "https://web-image-file.s3.ap-northeast-2.amazonaws.com/knock-knock-web/button05.png"
          }`}
          width={"50%"}
          onClick={() => {
            props.navigateAdStore(2608);
            props.adverClick(2608, "요녀석파스타");
          }}
        />
      </>
    );
  };

  return (
    <>
      {delightCustomList.map((data: any, index: number) => (
        <div
          style={{
            position: "relative",
          }}
          className="adverStoreWrap"
          key={index}
        >
          <div key={index}>
            {data.mime_type.includes("image") && (
              <div className="imageBox">
                <img className="adImg" src={data.url_path} alt="광고이미지" />
              </div>
            )}
            {data.mime_type.includes("video") && (
              <div className="imageBox">
                <video
                  className="adVideo"
                  id={`adVideo${index}`}
                  autoPlay
                  preload="auto"
                  muted
                  loop
                >
                  <source src={data.full_path} type="video/mp4" />
                </video>
              </div>
            )}
          </div>
          <div
            style={{
              position: "absolute",
              bottom: "10px",
              right: "3%",
              textAlign: "right",
            }}
          >
            <div className="customButtonWrap">
              {renderButtons(data.index, data.store_id)}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default CustomDelight;
